import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { InputComponent } from '@app/shared/components/forms/input/input.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'app-bet-input',
  standalone: true,
  imports: [
    SharedModule,
    InputComponent
],
	providers: [
	],
  templateUrl: './bet-input.component.html',
  styleUrl: './bet-input.component.scss'
})
export class BetInputComponent {
	@Input() betKey!: number;
	@Input() value?: any;
	@Output() valueChange: EventEmitter<string> = new EventEmitter<string>();


}
